<template>
  <div>
    <div class="pageloader is-active has-text-centered">
      <span
        class="title"
        v-html="$t('loading.message')"
      ></span>
    </div>
  </div>
</template>

<script>

export default {
  created () {
    // on récupère un éventuel initSearch depuis l'URL et on le stocke dans le store state si il existe
    var initSearch = this.readinitSearchUrlHashParams()
    if (initSearch) { this.$store.commit('auth/SET_INIT_SEARCH', initSearch) } else { this.$store.commit('auth/SET_INIT_SEARCH', '') }

    /* on récupère un éventuel token depuis l'URL et on le stocke dans le store state si il existe */
    var tokenURL = this.readUrlHashParams()
    if (tokenURL) { this.$store.commit('auth/SET_TOKEN_URL', tokenURL) }
    /* On teste si le token  est vide dans le store (vide = pas de token en URL ou pas de token en mémoire localstorage) - on  vire le gars vers APPYPACK */
    if (!this.$store.getters['auth/isLoggedIn']) {
      window.location = process.env.URL_SSO_FRONT
    } else {
      /* on fait une demande de récupération de user/me avec ce token de connexion 'mis à jour ou en mémoire' */
      this.$store.dispatch('auth/requireAuth', this.$store.getters['auth/getToken'])
    }
  },
  mounted () {
  },
  methods: {
    choosenLanguageFunction (value) {
      this.$i18n.locale = value
      this.$store.dispatch('changeLangue', value)
    },
    readUrlHashParams () {
      var tokenTrouve = false
      var hashParam = window.location.href.split('?')[1]
      if (hashParam) {
        var params = hashParam.split('&')
        params.forEach(function (element) {
          var paramSet = element.split('=')
          if (paramSet[0] === 't') {
            tokenTrouve = paramSet[1]
          }
        })
      }
      let urlString = window.location.href
      let url = new URL(urlString)
      let idEntreprise = url.searchParams.get('e')
      let idPlateforme = url.searchParams.get('p')
      var langColidee = url.searchParams.get('l')
      if (idEntreprise && idPlateforme) {
        this.choosenLanguageFunction(langColidee)
      }
      this.$store.dispatch('auth/setIdEntrepriseIdPlateforme', { idEntreprise: idEntreprise, idPlateforme: idPlateforme })

      return tokenTrouve
    },

    readinitSearchUrlHashParams () {
      var initSearchTrouve = false
      var hashParam = window.location.href.split('?')[1]
      if (hashParam) {
        var params = hashParam.split('&')
        params.forEach(function (element) {
          var paramSet = element.split('=')
          if (paramSet[0] == 'initSearch') {
            initSearchTrouve = paramSet[1]
          }
        })
      }
      return initSearchTrouve
    }

  }
}

</script>

<style type="text/css" scoped>
.pageloader {
  background: #424a60;
}
</style>



// WEBPACK FOOTER //
// src/components/Loading.vue